import React, { useState } from "react";
import { Button } from "../../UIKit/Button";
import { CataloguesProvider } from "./CataloguesProvider";
import DocumentationRoutes from "../Documentation/Routes";
import { dirbatImportFormat } from "./Catalogue";
import { Link } from "react-router-dom";
import { FileUploadZone } from "../../UIKit/form/FileUploadZone";
import { FormStepTitle } from "../../UIKit/form/FormStepTitle";
import { RadioChoice } from "../../UIKit/RadioChoice";
import { useIntl } from "react-intl";
import { DownloadAssetLink } from "../Documentation/DocumentationModule";

function AltLink(props: { label: string; route: string }) {
  return (
    <Link to={props.route} className="text-blue-500 underline text-sm ">
      {props.label}
    </Link>
  );
}

export function CatalogueForm(props: {
  catalogueProvider: CataloguesProvider;
  clientId: string;
  supplierId: string;
  onComplete: () => void;
}) {
  const [format, setFormat] = useState<dirbatImportFormat | undefined>(
    "dirbat_xls"
  );
  const [awaitsValidation, setAwaitsValidation] = useState<boolean>(true);
  const [file, setFile] = useState<File | undefined>(undefined);
  const formIsValid = format !== undefined && file !== undefined;
  const intl = useIntl();
  function onFormatChoose(value: dirbatImportFormat) {
    setFormat(value);
  }
  function onFileUpdate(file: File) {
    setFile(file);
  }
  function onSubmit(e: Event) {
    e.preventDefault();
    setAwaitsValidation(false);
    if (formIsValid) {
      props.catalogueProvider
        .add(format!, file!, props.supplierId)
        .then((c) => props.onComplete());
    }
  }

  let step = 1;
  return (
    <div>
      <h1 className="text-2xl font-bold py-4 px-2 sm:px-0">
        {intl.formatMessage({
          id: "import.new.catalogue",
          defaultMessage: "Import a new catalogue",
        })}
      </h1>
      <div className="mb-4">
        <FormStepTitle
          label={intl.formatMessage({
            id: "catalogues.choose.format",
            defaultMessage: "Select a data format",
          })}
          step={step++}
          required={true}
          isValid={format !== undefined}
          awaitsValidation={awaitsValidation}
        />
        <div className="flex flex-row ">
          <RadioChoice
            label={intl.formatMessage({
              id: "catalogues.formats.dirbat_xls",
              defaultMessage: "xlsx",
            })}
            onCheck={onFormatChoose}
            value={"dirbat_xls"}
            checked={format === "dirbat_xls"}
          >
            <strong>Tabular data, one file with several sheets</strong>
            <p>DirBat XLS allows you to use Excel to manage you data.</p>
            <DownloadAssetLink
              assetURL="/documentation/sample_products_dirbat_xls.xlsx"
              fileName="sample_products_dirbat_xls.xlsx"
              label={intl.formatMessage({
                id: "download.a.sample",
                defaultMessage: "download a sample",
              })}
            />{" "}
            |{" "}
            <AltLink
              label="access documentation"
              route={DocumentationRoutes(
                props.clientId,
                props.supplierId
              ).doc_import_catalogues("dirbat_xls")}
            />
          </RadioChoice>
          {/*<RadioChoice
            label="catalogues.formats.dirbat_json"
            onCheck={onFormatChoose}
            value={"dirbat_json"}
            checked={format === "dirbat_json"}
          >
            <strong>Données hiérarchisées, un seul fichier texte</strong>
            <p>
              Le format dirbat JSON permet de n'utiliser qu'un seul fichier,
              contenant l'ensemble des informations
            </p>
            <AltLink
              label="télécharger un exemple"
              route={Routes.doc_sample("dirbat_json")}
            />{" "}
            |{" "}
            <AltLink
              label="access documentation"
              route={Routes.doc_import("dirbat_json")}
            />
          </RadioChoice>*/}
        </div>
      </div>
      <div className="mb-4">
        <FormStepTitle
          label={intl.formatMessage({
            id: "catalogue.your.data",
            defaultMessage: "Your data",
          })}
          step={step++}
          required={true}
          awaitsValidation={awaitsValidation}
          isValid={file !== undefined}
        />
        <FileUploadZone
          onFileUpdate={onFileUpdate}
          onClear={() => setFile(undefined)}
          label={intl.formatMessage({
            id: "catalogue.field.label.your.file",
            defaultMessage: "Your data file",
          })}
          validationMessage="catalogues.field.file.is.mandatory"
          required={true}
          isValid={!!file}
          awaitsValidation={awaitsValidation}
        />
      </div>
      <Button
        onClick={(e) => onSubmit(e)}
        iconName="PlusIcon"
        label={intl.formatMessage({
          id: "catalogues.add.submit",
          defaultMessage: "Add this catalog",
        })}
      />
    </div>
  );
}
